import { Shield } from "lucide-react";
import { Badge } from "./badge";
import { cn } from "@/lib/utils";

interface RoleBadgeProps {
  role?: string;
  className?: string;
  variant?: "golden" | "default" | "pastel";
}

export function RoleBadge({
  role = "Admin",
  className,
  variant = "golden",
}: RoleBadgeProps) {
  return (
    <Badge
      className={cn(
        "inline-flex items-center gap-1 rounded-full",
        variant === "golden" && [
          "relative overflow-hidden px-2 py-0.5 font-medium text-white shadow-sm",
          "bg-gradient-to-r from-yellow-400 to-yellow-500 dark:from-yellow-500 dark:to-yellow-600",
          "before:animate-shimmer before:pointer-events-none before:absolute before:inset-0 before:bg-gradient-to-r before:from-transparent before:via-white/20 before:to-transparent",
        ],
        variant === "pastel" && [
          "border px-2 py-0.5 font-medium",
          "border-green-200 bg-green-100 text-green-700",
          "dark:border-green-700 dark:bg-green-900 dark:text-green-100",
        ],
        className,
      )}
      variant={variant === "default" ? "default" : "secondary"}
    >
      <Shield
        className={cn(
          "h-3 w-3",
          variant === "golden" ? "text-white" : "text-current",
          variant === "pastel" && "text-green-600 dark:text-green-200",
        )}
      />
      {role}
    </Badge>
  );
}
